export const scoreToPercentage = (num: number): string => (num * 100).toFixed(2) + " %";
